module.exports = __webpack_public_path__ + "media/images/logo-4d3b2fe93dadf35f43045a82d9e8fc3a.png";